export default __webpack_public_path__ + "static/media/timer.12ae0aeb.wav";